export const columnOptions: Array<{
  value: string;
  label: string;
}> = [
  { label: 'Id', value: 'ID' },
  { label: 'Status', value: 'STATUS' },
  { label: 'Volume', value: 'VOLUME' },
  { label: 'Cliente', value: 'CLIENTE' },
  { label: 'Veículo', value: 'VEICULO' },
  { label: 'Placa', value: 'PLACA' },
  { label: 'Motorista', value: 'MOTORISTA' },
  { label: 'Transportadora', value: 'TRANSPORTADORA' },
  { label: 'WMS Id', value: 'WMS ID' },
  { label: 'Data', value: 'DATA' },
  { label: 'Doca', value: 'DOCA' },
  { label: 'Código do Item', value: 'ITEM - CODIGO' },
  { label: 'Número da NF', value: 'NF' },
  { label: 'Descrição do Item', value: 'ITEM - DESCRICAO' },
  { label: 'Lote do Item', value: 'ITEM - LOTE' },
  { label: 'Quantidade do Item', value: 'ITEM - QUANTIDADE' },
  { label: 'Status do Item', value: 'ITEM - STATUS' },
  { label: 'NF', value: 'NF' },
];